cb.define([], function () {
  var RM_rm_shiftreceiptlist_filterVM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
        init: function (viewmodel) {
		viewmodel.on('afterInit', function () {
			debugger;
			//viewmodel.set("billnum","rm_retailvouchlist");
			//var teant = cb.rest.AppContext.user.tenant;
			var storeid = cb.rest.AppContext.user.storeId;
		
			var conditionPay = 
			{
				"isExtend": true,
				simpleVOs: []
			};
			
			conditionPay.simpleVOs.push({
				field: 'iStoreId.id',
				op: 'eq',
				value1: storeid
			});
			
			/*conditionPay.simpleVOs.push({
				field: 'tenant',
				op: 'eq',
				value1: teant
			});*/
			viewmodel.get('shiftInterlocutor.iShift').getFromModel().setFilter(conditionPay);
			
		});
	  
    }
  }
  try {
    module.exports = RM_rm_shiftreceiptlist_filterVM_Extend;
  } catch (error) {

  }
  return RM_rm_shiftreceiptlist_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_shiftreceiptlist_filterVM.Extend.js